import React from "react";
import PropTypes from "prop-types";
import EvidenceViewV2Support from "components/common/EvidenceViewV2Support";
import { TaskStatus } from "models";
import { TASK_TYPES } from "constant/task/types";

const ProgressEvidence = ({
  taskId,
  attachmentPrefix,
  evidenceStatus,
  evidencesMinRules,
  evidenceRef,
  progressEvidences,
  evidenceLoading,
  setEvidenceLoading,
  onAddOptimisticAttachments,
  onDeleteOptimisticAttachment,
  taskType,
  evidenceListHeight,
  position,
  loadingPosition,
  positionError,
}) => {
  return (
    <>
      <div>Para continuar el proceso de soporte adjunta evidencias fotográficas del avance de la tarea.</div>

      <EvidenceViewV2Support
        taskId={taskId}
        prefix={attachmentPrefix}
        status={evidenceStatus}
        min={evidencesMinRules}
        ref={evidenceRef}
        inputName="inProgress_inputFile"
        attachments={progressEvidences}
        loading={evidenceLoading}
        onLoading={setEvidenceLoading}
        onDeleteItem={onDeleteOptimisticAttachment}
        onEvidenceChange={onAddOptimisticAttachments}
        taskType={taskType}
        evidenceListHeight={evidenceListHeight}
        position={position}
        loadingPosition={loadingPosition}
        positionError={positionError}
      />
    </>
  );
};

ProgressEvidence.propTypes = {
  taskId: PropTypes.string.isRequired,
  attachmentPrefix: PropTypes.string.isRequired,
  evidenceStatus: PropTypes.oneOf([TaskStatus.IN_PROGRESS]).isRequired,
  evidencesMinRules: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  evidenceRef: PropTypes.any,
  progressEvidences: PropTypes.array,
  evidenceLoading: PropTypes.bool,
  setEvidenceLoading: PropTypes.func,
  onAddOptimisticAttachments: PropTypes.func,
  onDeleteOptimisticAttachment: PropTypes.func,
  taskType: PropTypes.oneOf(Object.values(TASK_TYPES)),
  evidenceListHeight: PropTypes.string,
  position: PropTypes.object,
  loadingPosition: PropTypes.bool,
  positionError: PropTypes.object,
};

ProgressEvidence.defaultProps = {
  taskId: "",
  attachmentPrefix: "",
  evidenceStatus: TaskStatus.IN_PROGRESS,
  evidencesMinRules: 1,
  evidenceRef: { current: null },
  progressEvidences: [],
  evidenceLoading: false,
  setEvidenceLoading: () => { },
  onAddOptimisticAttachments: () => { },
  onDeleteOptimisticAttachment: () => { },
  taskType: TASK_TYPES.SUPPORT,
  evidenceListHeight: "auto",
};

export default ProgressEvidence;
